<!--title -->
<app-modal-title
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<form [formGroup]="form" autocomplete="off">
  <!-- step1 insert mobile-->
  <section class="tw-m-[20px]" [class.d-none]="isShowStep2">
    <h5
      class="tw-text-center tw-mb-[15px] tw-flex-center flex-column tw-w-[250px] dark:tw-text-gray-300"
    >
      {{ "messages.insertMobile" | translate }}
    </h5>

    <div class="tw-flex-center flex-column">
      <!-- mobile -->
      <form-field
        type="tel"
        class="tw-w-full"
        label="common.mobile"
        [control]="form?.get('mobile')"
        [isOnlyNumber]="true"
        [maxLength]="12"
        [(value)]="mobile"
        (change)="convertMobile()"
      >
        <i suffix-content class="mdi mdi-cellphone mdi-23px"></i>
      </form-field>
      <!-- continue button -->
      <button
        [disabled]="form.get('mobile')?.invalid || !mobile || loading"
        mat-ripple
        class="btn tw-mt-3 tw-w-full"
        [themeColor]="'btn'"
        (click)="onShowStep2()"
      >
        <span *ngIf="!loading"> {{ "common.continuation" | translate }}</span>
        <!-- loading -->
        <ng-container *ngIf="loading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Loading...</span>
        </ng-container>
      </button>
    </div>
  </section>

  <!-- step2 auth code -->
  <section class="tw-m-[20px]" [class.d-none]="!isShowStep2">
    <h5
      class="tw-text-center tw-mb-[15px] flex-column tw-w-[250px] dark:tw-text-gray-400"
      style="line-height: 1.5"
    >
      <span class="tw-font-medium">
        <div
          [innerHTML]="
            'pages.systemManagement.users.userForm.userAuthMobile.enterVerificationCode'
              | translate : { mobile: mobile }
          "
        ></div>
      </span>
    </h5>

    <div class="tw-flex-center flex-column">
      <!-- authCode -->
      <form-field
        class="tw-w-full tw-relative"
        label="common.authCode"
        [minLength]="6"
        [maxLength]="6"
        [control]="form?.get('authCode')"
        [(value)]="authCode"
        type="tel"
        [isOnlyNumber]="true"
        classList="tw-text-xl dir-ltr"
      >
        <div content>
          <div class="tw-flex-center">
            <a
              class="resend-btn"
              (click)="onResendAuthCode()"
              [class]="
                timer == 0 || timer < 0
                  ? 'bg-info tw-cursor-pointer'
                  : 'bg-navyBlue'
              "
            >
              <span *ngIf="timer == 0 || timer < 0">
                {{ "common.resend" | translate }}
              </span>
              <span *ngIf="timer > 0" class="tw-text-white tw-font-medium">
                {{ timer | timer }}
              </span>
            </a>
          </div>
        </div>
      </form-field>
      <!-- Error -->
      <div class="row tw-text-right" *ngIf="isAuthCodeError">
        <span class="text-danger">
          <i class="fas fa-exclamation-circle text-danger"></i>
          {{ "messages.verificationCodeIsInvalid" | translate }}
        </span>
      </div>
      <!-- submit button -->
      <button
        [disabled]="form.get('authCode')?.invalid || !authCode"
        mat-ripple
        class="btn btn-hover-rise tw-mt-3 tw-w-full"
        [themeColor]="'btn'"
        (click)="onSubmit()"
      >
        <span *ngIf="!loading"> {{ "common.submit" | translate }}</span>
        <!-- loading -->
        <ng-container *ngIf="loading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Loading...</span>
        </ng-container>
      </button>
      <!-- submit button -->
      <button
        [disabled]="timer > 0"
        mat-ripple
        class="btn btn-secondary tw-mt-3 tw-w-full"
        (click)="isShowStep2 = false"
      >
        {{ "common.changeMobileNumber" | translate }}
      </button>
    </div>
  </section>
</form>
